import { FC } from "react";
import cx from "classnames";
import { toolkitCx } from "@sundae/ui-toolkit";

const LiquidityPoolMigrationListItemSkeleton: FC = () => {
  return (
    <div className={cx("h-[84px] w-full rounded-lg", toolkitCx.layout.background.secondary)} />
  );
};

export default LiquidityPoolMigrationListItemSkeleton;
